







































import { Component, Vue, Inject } from 'vue-property-decorator'

@Component
export default class GuideKetang extends Vue {
  loaded: boolean = false // 页面是否已经加载完成
  showBtnScrolltop: boolean = false // 显示返回顶部按钮
  mediaPath: string = 'https://s.doumiao9.com/official'
  @Inject() appAuth!: (silent?: boolean) => Promise<{}>
  to (path: string) {
    Lib.router.push(path)
  }
  back () {
    Lib.router.go(-1)
  }
  toAnchor (selector: string) {
    log.debug('[Shansuan toAnchor] selector:', selector)
    let anchor = document.querySelector(selector)
    if (!anchor) { return }
    document.documentElement.scrollTop = (anchor as HTMLElement).offsetTop
    document.body.scrollTop = (anchor as HTMLElement).offsetTop
  }
  scrollTop () {
    document.documentElement.scrollTop = 0
    document.body.scrollTop = 0
  }
  created () {
    this.loaded = true
  }
  mounted () {
    this.scrollTop()
    // 兼容prerender-spa-plugin
    Lib.dispatchEvent(document, 'custom-render-trigger')
    let btnScrollTop = document.querySelector('.btn-scrolltop')
    let btnBack = document.querySelector('.back')
    let links = document.querySelectorAll('.menu-link')
    if (btnScrollTop) {
      btnScrollTop.addEventListener('click', this.scrollTop)
      window.addEventListener('scroll', () => {
        if (document.documentElement.scrollTop >= 200 || document.body.scrollTop >= 200) {
          this.showBtnScrolltop = true
          btnScrollTop!.classList.add('btn-scrolltop--show')
        } else {
          this.showBtnScrolltop = false
          btnScrollTop!.classList.remove('btn-scrolltop--show')
        }
      })
    }
    if (btnBack) {
      btnBack.addEventListener('click', this.back)
    }
    if (links && links.length) {
      for (let i = 0; i < links.length; i++) {
        links[i].addEventListener('click', (event) => {
          let tag = (event.currentTarget as HTMLElement)
          if (!tag || !tag.dataset) { return }
          if (tag.dataset.anchor) {
            this.toAnchor(tag.dataset.anchor)
          }
        })
      }
    }
  }
}
